import {
  BlockedContactsRestrictedRoles,
  TextRestrictedRoles,
  USER_ACCOUNT_ROLE_KEYS,
} from "constants/account.roles.constants";
import { NEW_SCREENS } from "constants/screens.constants";

/**
 * Check if a user has grasshopper access
 */
export const checkGrassHopper = (user) => {
  return (
    user?.userAccountRoles?.filter((role) =>
      role.userRoleKey.includes(USER_ACCOUNT_ROLE_KEYS.GRASSHOPPER)
    ).length > 0
  );
};

/**
 *
 * @returns the current screen name based on current path
 */
export const getCurrentScreen = (availableScreens, path) => {
  let screenName;
  let defaultName;
  // Check if the path belongs to a new screen
  Object.keys(NEW_SCREENS).forEach((key) => {
    const currentScreenName = NEW_SCREENS[key];
    if (path.includes(currentScreenName.path)) {
      screenName = currentScreenName.name;
    }
  });
  // If screenName is found in new screens
  if (screenName !== undefined) {
    return screenName;
  }
  availableScreens.forEach((screen) => {
    if (screen.path === path) {
      screenName = screen.name;
      return screen.name;
    }
    if (screen.default) {
      defaultName = screen.name;
    }
  });
  if (!screenName) {
    return defaultName;
  } else {
    return screenName;
  }
};
/**
 *
 * @param {*} user The user object
 * @param {*} role The role to be checked
 * @returns a boolean indicting whether the user has the role or not
 */
export const userHasRole = (user, role) => {
  if (
    (user?.userAccountRoles?.filter((account) => account.userRoleKey === role)
      .length || 0) > 0
  ) {
    return true;
  }
  return false;
};
/**
 * Check if a user any role other than the one passed as an argument
 */
export const userHasOneRoleExcept = (user, role) => {
  return !!user?.userAccountRoles?.find(
    (account) => account.userRoleKey !== role
  );
};

/**
 * Check if a user any role other than the one passed as an argument
 */
export const userHasRoleExclude = (user, roles) => {
  return !!user?.userAccountRoles?.find(
    (account) => !roles.includes(account.userRoleKey)
  );
};

export const canAccessTexts = (user, accountId = undefined) => {
  return userHasRoleExclude(
    accountId
      ? {
          ...user,
          userAccountRoles: user.userAccountRoles.filter(
            (account) => account.accountId === accountId
          ),
        }
      : user,
    TextRestrictedRoles
  );
};

export const canAccessChatActivity = (user) =>
  user?.userAccountRoles?.find((role) => role.chatServiceEnabled === "Y");

export const canAccessBlockedContacts = (user, accountId = undefined) => {
  return userHasRoleExclude(
    accountId
      ? {
          ...user,
          userAccountRoles: user.userAccountRoles.filter(
            (account) => account.accountId === accountId
          ),
        }
      : user,
    BlockedContactsRestrictedRoles
  );
};

export const getDistictFilteredAccounts = (user, filterCondition) => {
  const distinctAccounts = [];
  return (user.userAccountRoles || []).filter((role, index, arr) => {
    if (
      filterCondition(role) &&
      distinctAccounts.indexOf(role.accountId) === -1
    ) {
      distinctAccounts.push(role.accountId);
      return true;
    } else {
      return false;
    }
  });
};

export const searchField = (field, search) => {
  if (typeof field !== "string") {
    return false;
  }
  if (typeof search !== "string" || search.length === 0) {
    return false;
  }
  return field.toUpperCase().includes(search);
};

/**
 *
 * @param {*} daysAgo The number of days prior to today
 * @returns A Date Object
 */
export const getPreviousDate = (daysAgo) => {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return date;
};
